import { Link } from "react-router-dom";
import { HOT_ARTICLES } from "@/mocks/articles";
import { categoryName } from "@/mocks/site";
import { Eyebrow } from "@/components/ui/primitives";

export default function HotStories() {
  const lead = HOT_ARTICLES[0];
  const rest = HOT_ARTICLES.slice(1, 5);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <Eyebrow text="大家都在看" en="Hot" />
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">片场最热，是真细节</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              被读者讨论最多、转发最多的幕后记录。不讲空话，只讲那条NG、那场雨与那台被拆了又装的机器。
            </p>
          </div>
          <Link
            to="/column"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-300 transition hover:text-primary-200"
          >
            看全部幕后 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          {/* leading big story */}
          <Link
            to={`/story/${lead.slug}`}
            className="group relative block overflow-hidden rounded-lg"
            aria-label={lead.title}
          >
            <img
              src={lead.hero}
              alt={`${lead.title} 幕后摄影`}
              className="h-full min-h-[280px] w-full object-cover object-top transition duration-500 group-hover:scale-105 md:min-h-[440px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-background-50/5" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-100">
                  <i className="ri-fire-fill" /> 本周最热
                </span>
                <span className="rounded-full bg-background-50/70 px-2.5 py-1 text-xs text-primary-300">
                  {categoryName(lead.category)}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-3xl">
                {lead.title}
              </h3>
              <p className="mt-2 hidden text-sm leading-relaxed text-foreground-500 md:block">{lead.excerpt}</p>
              <p className="mt-3 text-xs text-foreground-400">
                {lead.author} · {lead.date} · 约 {lead.readMin} 分钟
              </p>
            </div>
          </Link>

          {/* recent rows */}
          <div className="flex flex-col gap-4">
            {rest.map((a) => (
              <Link
                key={a.id}
                to={`/story/${a.slug}`}
                className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition hover:border-primary-400/40"
              >
                <img
                  src={a.hero}
                  alt={a.title}
                  className="h-24 w-28 shrink-0 rounded-md object-cover object-top md:h-28 md:w-36"
                />
                <div className="flex min-w-0 flex-1 flex-col py-1">
                  <span className="text-xs text-primary-400">{categoryName(a.category)}</span>
                  <h4 className="mt-1 line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition group-hover:text-primary-200">
                    {a.title}
                  </h4>
                  <p className="mt-auto line-clamp-1 hidden text-xs text-foreground-600 sm:block">{a.excerpt}</p>
                  <p className="mt-1 text-xs text-foreground-500">
                    {a.date} · 约 {a.readMin} 分钟 · {a.views}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}